import type { OwnerRezWidget } from '../types';

type Props = {
  widget: OwnerRezWidget;
};

export default function OwnerRezEmbed({ widget }: Props) {
  return (
    <div
      className="ownerrez-widget"
      data-ownerrez-kind={widget.kind}
      data-propertyid={widget.propertyId}
      data-widget-type={widget.widgetType}
      data-widgetid={widget.widgetId}
    />
  );
}
